import { Grid, Typography } from "@material-ui/core";

export const steps = [
  {
    target: ".home_top_activity_slider",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">اسلایدر فعالیت‌ها</Typography>
        <Typography>
          در این قسمت لیستی از فعالیت‌های برگزیده به نمایش گذاشته شده است.
        </Typography>
      </Grid>
    ),
    disableBeacon: true,
    placement: window.innerWidth < 768 ? "top" : "bottom",
  },
  {
    target: ".home_kpis",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">آمار سامانه</Typography>
        <Typography>
          این قسمت آماری از تعداد انجمن‌ها، مربیان متصل، تعداد قرارگاه‌ها، تعداد
          فعالیت‌ها، تعداد اعضا و درصد پوشش مدارس در سطح کشور نمایش داده شده
          است.
        </Typography>
      </Grid>
    ),
    disableBeacon: false,
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".home_best_in_month",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">مدارس برتر</Typography>
        <Typography>
          در این قسمت سه مدرسه برتر لیگ عقیق در رشته‌های زبدگان، پدیدگان،
          شهرت‌آفرینان و مشاهیر معرفی شده است.
        </Typography>
      </Grid>
    ),
    disableBeacon: false,
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".home_newest_activity",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">تازه‌ترین فعالیت‌ها</Typography>
        <Typography>
          در این قسمت لیستی از تازه‌ترین فعالیت‌ها به نمایش گذاشته شده است.
        </Typography>
      </Grid>
    ),
  },
  {
    target: ".activities_my_boom",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">بوم من</Typography>
        <Typography>
          صفحه بوم من، لیستی از فعالیت مدارس مورد علاقه شما که دنبال کننده‌
          آن‌ها هستید به نمایش می گذارد.
        </Typography>
      </Grid>
    ),
    disableBeacon: true,
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_boom_activity_title",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">عنوان فعالیت</Typography>
        <Typography>در این قسمت عنوان فعالیت ذکر شده است.</Typography>
      </Grid>
    ),
    styles: { spotlight: { padding: "3px" } },
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_boom_activity_school",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">لایه انجام‌دهنده فعالیت</Typography>
        <Typography>
          در این قسمت لایه انجام دهنده این فعالیت ذکر شده است.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_boom_activity_location",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">شهر محل فعالیت</Typography>
        <Typography>
          در این قسمت شهر محل انجام این فعالیت ذکر شده است.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_boom_activity_view_count",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">تعداد بازدیدکنندگان</Typography>
        <Typography>
          در این قسمت تعداد بازدیدکنندگان این فعالیت ذکر شده است.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_boom_activity_comment_count",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">تعداد نظرات</Typography>
        <Typography>
          در این قسمت تعداد نظرات در مورد این فعالیت ذکر شده است.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_boom_activity_get_guide_count",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">دفعات الگو شدن</Typography>
        <Typography>
          تعداد دفعاتی که این فعالیت توسط دیگران برای انجام فعالیتشان الگو گرفته
          شده است.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_boom_activity_like_count",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">تعداد لایک</Typography>
        <Typography>
          تعداد دفعاتی که این فعالیت توسط دیگران مورد پسند قرار گرفته
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_search",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">کاوش</Typography>
        <Typography>
          صفحه کاوش، لیست فعالیت‌های ثبت شده در سامانه عقیق را به نمایش
          می‌گذارد.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target:
      window.innerWidth < 768
        ? ".activities_search_filter_mobile"
        : ".activities_search_filter",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">فیلتر صفحه کاوش</Typography>
        <Typography>
          در این قسمت شما امکان اعمال فیلترهایی از جمله نوع مرتب سازی، استان،
          شهرستان و لایه انجام دهنده جهت یافتن فعالیت‌های مورد نظرتان را دارید.
        </Typography>
      </Grid>
    ),
    padding: "0px",
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "left",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_activities",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">فعالیت‌های من</Typography>
        <Typography>
          صفحه‌ی فعالیت‌های من، لیست فعالیت‌هایی که شما ثبت کردید را به نمایش
          می‌گذارد.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target:
      window.innerWidth < 768
        ? ".activities_my_activities_checkbox_mobile"
        : ".activities_my_activities_checkbox_inProgress",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">فعالیت‌های در حال بررسی</Typography>
        <Typography>
          با انتخاب گزینه درحال بررسی شما می‌توانید فعالیت‌هایی که ثبت کردید ولی
          هنوز توسط مربی بررسی نشده را مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_activities_checkbox_confirm",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">فعالیت‌های تایید شده</Typography>
        <Typography>
          با انتخاب گزینه تایید شده شما می‌توانید لیست فعالیت‌هایی که مربی تایید
          کرده را مشاهده کنید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_activities_checkbox_fail",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">نیاز به اصلاح</Typography>
        <Typography>
          با انتخاب گزینه نیاز به اصلاح شما می‌توانید لیست فعالیت‌هایی که مربی
          رد کرده و نیاز به اصلاح دارد را مشاهده کنید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_follow",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">دنباله‌های من</Typography>
        <Typography>
          صفحه دنباله‌های من، لیستی از مدارس، قرارگاه‌ها یا مدارسی را که شما
          دنبال کننده فعالیت‌های آن‌ها هستید را به نمایش می‌گذارد.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_my_follow_following",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">لغو دنبال کردن</Typography>
        <Typography>
          شما با کلیک به روی گزینه لغو دنبال کردن می توانید مدرسه، قرارگاه یا
          اتحادیه ای را که دیگر تمایل به دنبال کردنش ندارید، از لیست دنباله‌های
          من حذف نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".activities_add_activity",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">ثبت فعالیت جدید</Typography>
        <Typography>
          با کلیک به روی گزینه + شما می توانید وارد صفحه ثبت فعالیت جدید شوید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_role",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">addActivity/step22</Typography>
        <Typography>
          Yet another loader simulation and now we reached the last step in our
          tour!
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_title",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">عنوان فعالیت</Typography>
        <Typography>در این قسمت عنوان فعالیت را بنویسید.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_category",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">قالب فعالیت</Typography>
        <Typography>
          در این قسمت قالب مربوط به فعالیت خود را انتخاب کنید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_subject",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">موضوع فعالیت</Typography>
        <Typography>
          در این قسمت موضوع یا موضوعات مربوط به فعالیت خود را انتخاب کنید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_participants",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">شرکت‌کنندگان</Typography>
        <Typography>در این قسمت افراد شرکت کننده را انتخاب نمایید.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_where_do",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">مکان اجرای فعالیت</Typography>
        <Typography>در این قسمت مکان اجرای فعالیت را ذکر نمایید.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_start_date",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">تاریخ آغاز فعالیت</Typography>
        <Typography>در این قسمت تاریخ آغاز فعالیت را انتخاب نمایید.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_end_date",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">تاریخ پایان فعالیت</Typography>
        <Typography>
          در این قسمت تاریخ پایان فعالیت را انتخاب نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_school_name",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">addActivity/step30</Typography>
        <Typography>
          Yet another loader simulation and now we reached the last step in our
          tour!
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_with_manager",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">حضور مسئول قرارگاه</Typography>
        <Typography>
          دراین قسمت حضور یا عدم‌حضور مسئول قرارگاه را مشخص کنید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_description",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">شرح فعالیت</Typography>
        <Typography>
          در این قسمت خلاصه‌ای از فعالیت انجام شده شرح دهید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_get_guid",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">الگو گرفتن</Typography>
        <Typography>
          اگر قبلا از فعالیتی برای انجام این فعالیت الگو گرفته‌‌اید و گزینه الگو
          گرفتن از آن فعالیت را نیز زده‌اید، در اینجا می‌توانید آن را با انتخاب
          این گزینه ذکر نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_upload_video_image",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">آپلود تصویر و ویدیو</Typography>
        <Typography>
          در این قسمت می‌توانید تصاویر و ویدیو‌های مربوط به فعالیت خود را یک به
          یک انتخاب نمایید و هر بار به روی گزینه ذخیره کلیک نمایید. فقط توجه
          داشته باشید که مجموع حجم فایل‌ها پایین باشد.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_upload_doc",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">آپلود اسناد</Typography>
        <Typography>
          در این قسمت می‌توانید اسناد مربوط به فعالیت خود غیر از تصاویر و
          ویدیو‌ها را بارگذاری نمایید.{" "}
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".add_activity_save",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">ذخیره</Typography>
        <Typography>
          در نهایت با انتخاب این گزینه فعالیت شما ثبت می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_date_slider",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">دوره رقابت</Typography>
        <Typography>
          در این قسمت می‌توانید با تغییر نوع دوره رقابت، نتایج لیگ را در آن دوره
          رقابت مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_hotshot",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">زبدگان</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید برترین های زبدگان یعنی افرادی که بیشترین
          امتیاز را در ثبت فعالیت کسب کرده‌اند، را مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_popular",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">مشاهیر</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید برترین های مشاهیر یعنی افرادی که بیشترین
          لایک وکامنت را دریافت کردند و همچنین فعالیت‌هایشان بیشتر از دیگران
          الگو گرفته شده است، را مشاهده نمایید.{" "}
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_liker",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">شهرت‌آفرینان</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید برترین های شهرت آفرینان یعنی افرادی که
          بیشتر در سامانه عقیق در حال تعامل با دیگران هستند و اصطلاحا شهرت آفرین
          هستند، را مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_pioneer",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">پدیدگان</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید برترین های پدیدگان یعنی افرادی که نسبت
          به دوره رقابت قبل بیشترین رشد را داشته‌اند، را مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_league",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">نوع لیگ</Typography>
        <Typography>
          در این قسمت می‌توانید با تغییر نوع لایه تشکیلاتی، نتایج لیگ را برای آن
          سطح از تشکیلات مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_gender",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">جنسیت</Typography>
        <Typography>
          در این قسمت می‌توانید، نتایج لیگ را برای جنسیت مورد نظرتان مشاهده
          نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_national",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">گستره</Typography>
        <Typography>
          در این قسمت می‌توانید با تغییر گستره جغرافیایی، نتایج لیگ را در آن
          گستره مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_item_name",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">نام لایه تشکیلاتی</Typography>
        <Typography>
          در این قسمت از جدول لیگ، نام لایه تشکیلاتی مورد نظر مشاهده می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_item_location",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">شهر محل لایه تشکیلاتی</Typography>
        <Typography>
          در این قسمت از جدول لیگ، شهر محل لایه تشکیلاتی مورد نظر مشاهده می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_item_rank",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">رتبه</Typography>
        <Typography>
          در این قسمت از جدول لیگ، رتبه لایه تشکیلاتی مورد نظر مشاهده می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".league_item_score",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">امتیاز</Typography>
        <Typography>
          در این قسمت از جدول لیگ، امتیاز لایه تشکیلاتی مورد نظر مشاهده می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_inbox",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">صندوق دریافت</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید، نامه‌های دریافت شده خود را مشاهده
          نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_inbox_personal",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">شخصی</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید نامه‌های شخصی خود را مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_inbox_hamraz",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">همراز</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید نامه‌های مربوط به مشاوره‌ی همراز را
          مشاهده نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_inbox_search",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">جستجوی نامه</Typography>
        <Typography>
          در این قسمت می‌توانید نامه‌ی مورد نظر خود را براساس نام فرد یا عنوان
          نامه جستجو کنید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,

    scrollToSteps: false,
  },
  {
    target: ".messaging_sendBox",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">صندوق ارسال</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید، نامه‌های ارسال شده خود را مشاهده
          نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_archive",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">بایگانی</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید، نامه‌هایی که بایگانی کردید را مشاهده
          نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_my_contact",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">مخاطبین من</Typography>
        <Typography>
          در این قسمت لیست مخاطبین شما نمایش داده شده است فقط توجه داشته باشید
          شما در پروفایل هر فرد امکان افزودن آن به مخاطبینتان را دارید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_consulting",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">مشاوره جدید</Typography>
        <Typography>
          جهت ایجاد یک نامه‌ی مشاوره‌ی همراز این قسمت را انتخاب نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_consulting_title",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">عنوان مشاوره</Typography>
        <Typography>در این قسمت عنوان نامه‌ی مشاوره را ذکر کنید.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_consulting_subject",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">موضوع مشاوره</Typography>
        <Typography>
          در این قسمت موضوع نامه‌ی مشاوره خود را انتخاب کنید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_consulting_text",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">متن مشاوره</Typography>
        <Typography>
          Yet another loader simulation and now we reached the last step in our
          tour!
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_consulting_send",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">ارسال نامه‌ی مشاوره</Typography>
        <Typography>
          با انتخاب این گزینه نامه یا پیام شما ارسال می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_message",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">پیام جدید</Typography>
        <Typography>
          اگر قصد ارسال پیام به فردی را دارید، این قسمت را انتخاب کنید فقط توجه
          داشته باشید این فرد را قبلا می بایست به مخاطبین خود افزوده باشید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_message_title",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">عنوان پیام</Typography>
        <Typography>در این قسمت عنوان نامه‌ را ذکر کنید.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_message_to",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">مخاطب پیام</Typography>
        <Typography>در این قسمت مخاطب پیام خود را انتخاب نمایید.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_message_text",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">متن پیام</Typography>
        <Typography>در این قسمت متن پیام خود را وارد نمایید.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".messaging_new_message_send",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">ارسال پیام</Typography>
        <Typography>
          با انتخاب این گزینه نامه یا پیام شما ارسال می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_profile_adjectiveSlider",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">نشان کاربر</Typography>
        <Typography>
          این قسمت نشان کاربر را براساس مدت زمان و تعداد فعالیت نشان می‌دهد.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_profile_fullName",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">نام کاربر</Typography>
        <Typography>در این قسمت نام کاربر نمایش داده می‌شود.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_profile_role",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">نوع کاربر</Typography>
        <Typography>این قسمت نوع کاربر را نشان می‌دهد.</Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_profile_information",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">سن و تعداد فعالیت کاربر</Typography>
        <Typography>
          در این قسمت سن و تعداد فعالیت ثبت شده کاربر نمایش داده می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_profile_about_me",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">myProfile/step69</Typography>
        <Typography>
          Yet another loader simulation and now we reached the last step in our
          tour!
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_profile_organization",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">سوابق تشکیلاتی</Typography>
        <Typography>
          در این قسمت سوابق تشکیلاتی کاربر نمایش داده می‌شود.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_profile_user_boom",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">بوم کاربر</Typography>
        <Typography>
          قسمت بوم کاربر، در واقع لایه‌های تشکیلاتی دنبال شده توسط کاربر را نشان
          می‌دهد.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_select_date",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">سال تحصیلی</Typography>
        <Typography>
          در این قسمت با انتخاب سال تحصیلی مورد نظر اطلاعات مربوط به لایه
          تشکیلاتی مورد نظر در آن سال را مشاهده می‌کنید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_name",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">نام لایه تشکیلاتی</Typography>
        <Typography>
          در این قسمت نام لایه تشکیلاتی مورد نظر ذکر شده است.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_location",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">محل لایه تشکیلاتی</Typography>
        <Typography>
          در این قسمت محل لایه تشکیلاتی مورد نظر ذکر شده است.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_follower_count",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">تعداد دنبال‌کنندگان</Typography>
        <Typography>
          این قسمت تعداد دنبال کننده‌های لایه تشکیلاتی مورد نظر را نشان می‌دهد.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_member_count",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">تعداد اعضاء</Typography>
        <Typography>
          این قسمت تعداد اعضای این لایه تشکیلاتی را نمایش می‌دهد.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_profile_avatar",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">عکس پروفایل</Typography>
        <Typography>
          در این قسمت می‌توانید عکس پروفایل لایه تشکیلاتی را مشاهده نمایید. در
          صورتی که وارد صفحه لایه تشکیلاتی خود شوید از این قسمت می‌توانید عکس
          پروفایلش را تغییر دهید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_rank",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">وضعیت لیگ لایه تشکیلاتی</Typography>
        <Typography>
          در این قسمت رتبه‌های مربوط به لایه تشکیلاتی مورد نظر در رشته‌های
          زبدگان، مشاهیر، شهرت‌آفرینان و پدیدگان نمایش داده شده است.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_following_btn",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">دنبال کردن</Typography>
        <Typography>
          با انتخاب این گزینه می‌توانید لایه تشکیلاتی مورد نظر را به دنباله‌های
          خود اضافه نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },

  {
    target: ".my_school_member_list",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">لیست اعضاء</Typography>
        <Typography>
          در این قسمت می‌توانید لیست اعضای لایه تشکیلاتی مورد نظر را مشاهده
          نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_member_list_add_member",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">افزودن عضو</Typography>
        <Typography>
          مسئول لایه تشکیلاتی می‌تواند در این قسمت اعضای جدید را به لیست اعضای
          خود اضافه کند.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
  {
    target: ".my_school_member_list_activities",
    content: (
      <Grid container direction="column" alignItems="center">
        <Typography variant="body1">لیست فعالیت‌ها</Typography>
        <Typography>
          در این قسمت می‌توانید لیست فعالیت‌های لایه تشکیلاتی مورد نظر را مشاهده
          نمایید.
        </Typography>
      </Grid>
    ),
    offset: 5,
    placement: window.innerWidth < 768 ? "top" : "bottom",
    isFixed: window.innerWidth < 768 ? true : false,
  },
];
